import React, {useState} from 'react';
import {Tabs, Tab} from '@mui/material';
import SchoolDashboardShell from '../components/SchoolDashboard.comp';
import {ORANGE} from '../components/widgets.comp';
import ParticipationOverviewTab from '../tabs/ParticipationOverview.tab';
import ParticipationByGradeTab from '../tabs/ParticipationByGrade.tab';
import ParticipationByClassTab from '../tabs/ParticipationByClass.tab';

const tabSx = {
    borderBottom: '1px solid #E5E7EB', mb: 3,
    '& .MuiTab-root': {textTransform: 'none', fontWeight: 600, fontSize: '14px', color: '#6A7282', px: 2, whiteSpace: 'nowrap', minHeight: 48},
    '& .Mui-selected': {color: `${ORANGE} !important`},
};

const ParticipationPage = () => {
    const [tab, setTab] = useState(0);
    return (
        <SchoolDashboardShell
            needsAssessmentResults
            tabs={
                <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto"
                      TabIndicatorProps={{style: {backgroundColor: ORANGE}}} sx={tabSx}>
                    <Tab label="Overview"/>
                    <Tab label="By Grade"/>
                    <Tab label="By Class"/>
                </Tabs>
            }
        >
            {tab === 0 && <ParticipationOverviewTab/>}
            {tab === 1 && <ParticipationByGradeTab/>}
            {tab === 2 && <ParticipationByClassTab/>}
        </SchoolDashboardShell>
    );
};

export default ParticipationPage;
